// src/api/dialer.js
import { apiClient } from './auth'

// 🔑 Fetch Telnyx JWT token for WebRTC
export function fetchDialerToken() {
  return apiClient.get('/neue/admin/telnyx/token')
}


export function rejectCall(callControlId) {
  return apiClient.post('/neue/admin/telnyx/reject-call', {
    callControlId
  })
}